import {
  demoCharge,
  demoCoinHistory,
  demoDeviceLists,
  demoDeviceSales,
  demoMonthSales,
  demoPeak,
  demoStoreState,
  demoSumSales,
  demoTerminals,
  demoTotalSales,
} from './demoPayloads';

const pathOf = (url: string) => {
  const clean = url.split('?')[0];
  return clean.startsWith('/') ? clean : `/${clean}`;
};

/** 체험 세션의 조회 응답. 매장 연결과 무관하게 화면용 데이터만 돌려준다. */
export const demoGetPayload = (
  url: string,
  params?: Record<string, unknown>,
): unknown | undefined => {
  const path = pathOf(url);
  if (path.includes('/check-login') || path.includes('/logout')) return true;
  if (path.includes('/login')) return undefined;
  if (path.includes('/download')) return undefined;

  if (path.includes('/user/init/main') || path.includes('/master/init/main')) {
    return demoStoreState();
  }
  if (path.includes('/switch/store/')) {
    const store = demoStoreState();
    return {
      currentStore: store.currentStore,
      currentAuthority: store.currentAuthority,
      storeId: store.currentStoreId,
      mileageDisplayYn: 'Y',
    };
  }
  if (path.includes('/user/monthly/')) {
    const month = path.split('/').filter(Boolean).pop();
    return demoMonthSales(month);
  }
  if (path.includes('/user/dashboard/summary')) return demoMonthSales();
  if (path.includes('/sales/total') || path.includes('/store/sales/total')) return demoTotalSales();
  if (path.includes('/sales/sum') || path.includes('/store/sales/sum')) return demoSumSales();
  if (path.includes('/user/sales/devices/summary') || path.includes('/user/sales/devices')) {
    return demoDeviceSales();
  }
  if (/\/user\/device\/\d+/.test(path)) return demoDeviceLists();
  if (/\/user\/store\/deposit\/\d+/.test(path)) {
    const year = Number(path.split('/').filter(Boolean).slice(-2)[0]);
    return demoCharge(year);
  }
  if (path.includes('/sales/peak')) {
    return demoPeak(typeof params?.kind === 'string' ? params.kind : undefined);
  }
  if (path.includes('/stock')) return demoTerminals().map((row) => ({ catId: row.catId, stock: 20 }));
  if (path.includes('/websocket/terminals')) return demoTerminals();
  if (path.includes('/service-coin/history')) return demoCoinHistory();
  if (path.includes('/user/popup')) return null;
  if (path.includes('/notice/access')) {
    return {
      canWrite: false,
      canGrant: false,
      canCreate: false,
      canUpdate: false,
      canDelete: false,
    };
  }
  if (path.includes('/store-admin/access')) return { canRead: false };
  if (path.includes('/user/store/') && path.includes('/cctv')) return [];
  if (path.includes('/store-authority/') || path.includes('/user-list')) return [];
  return [];
};

export const isDemoMutationBlocked = (method: string | undefined, url: string) => {
  const verb = (method || 'get').toLowerCase();
  if (verb === 'get' || verb === 'head' || verb === 'options') return false;
  return !pathOf(url).includes('/login');
};
